import React, { useEffect, useState } from "react";
import { Pie } from "@ant-design/plots";
import { colors } from "../../core/theme";
import UserServices from "../../services/UserServices";

const PieCompanyActivePatients = ({ selectedData, onClick, loadingParent }) => {
  const [loading, setLoading] = useState(false);

  const [config, setConfig] = useState({
    appendPadding: 10,
    data: null,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.8,
    label: {
      type: "outer",
      offset: 0,
      content: "{value}",
      style: {
        textAlign: "center",
        fontSize: 14,
      },
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "",
      },
    },
    legend: {
      layout: "horizontal",
      position: "bottom",
    },
    color: [colors.custom_green, colors.custom_red],
  });

  useEffect(() => {
    if (loadingParent === false) {
      getPieActivePatients();
    }
  }, [selectedData, loadingParent]);

  const getPieActivePatients = async () => {
    setLoading(true);
    try {
      const response = await UserServices.getEndSubscriptions(
        selectedData.enterprise,
        1,
        1
      );
      if (response.status >= 200 && response.status < 300) {
        setConfig((v) => ({
          ...v,
          data: [
            {
              type: "Activos",
              value: response.data.with_subscription_active,
            },
            {
              type: "Inactivos",
              value: response.data.without_subscription_active,
            },
          ],
        }));
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleClick = (data) => {
    if (onClick) {
      onClick(data);
    }
  };

  return (
    <div className="relative" style={{ minHeight: 318, height: "100%" }}>
      {(config.data === null || loading) && (
        <div
          style={{
            height: 260,
            width: 260,
            borderRadius: 900,
            border: "24px solid lightgray",
            left: "50%",
            transform: "translateX(-50%)",
            position: "absolute",
            top: 20,
          }}
        ></div>
      )}
      {config.data !== null && !loading && (
        <Pie
          {...config}
          onEvent={(chart, event) => {
            if (event.type === "click") {
              handleClick(event.data.data);
            }
          }}
        />
      )}
    </div>
  );
};

export default PieCompanyActivePatients;
